export default "__VITE_ASSET__L$eqJvqe__"